export default "__VITE_ASSET__BO6FoL2k__"